module.exports = __webpack_public_path__ + "img/youtube.5cb21ddc.png";